import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { RoutingQueryParamsName } from '@core/router/routing.params';
import { TariffsState } from '../state/tariffs.state';
import { TariffVersion } from '@api/models/TariffEditorApi/Contract/tariff-version';


@Injectable()
export class TariffVersionDetailResolverService {
    readonly #tariffsState: TariffsState = inject(TariffsState);

    public resolve(
        route: ActivatedRouteSnapshot,
    ): Observable<TariffVersion> | Observable<never> {
        const versionId: string = decodeURIComponent(route.paramMap.get(RoutingQueryParamsName.VersionId));

        return this.#tariffsState.getTariffVersionById(versionId).pipe(filter(Boolean), take(1));
    }
}
